import { render, staticRenderFns } from "./bright_spot.vue?vue&type=template&id=5d5c32fa&scoped=true&"
import script from "./bright_spot.vue?vue&type=script&lang=js&"
export * from "./bright_spot.vue?vue&type=script&lang=js&"
import style0 from "./bright_spot.vue?vue&type=style&index=0&id=5d5c32fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c32fa",
  null
  
)

export default component.exports